import { combineReducers } from 'redux'
import unities from './unities'

export default combineReducers({
  unities,
})